import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';

import { useAppDispatch } from '@pkg/hooks';

import { callGetYatPageProfile } from '@app/client/resources/yat-pages/pages.ts';
import { getLiquidIdCollectionItems, getUserSettings, getYatPageItems } from '@app/store/actions/yat-page-items';
import { setYatPage } from '@app/store/slices';

export function useGetYatPageProfile() {
    const dispatch = useAppDispatch();

    const { data, ...rest } = useQuery({
        queryKey: ['yatPageV2', 'profile'],
        queryFn: () => callGetYatPageProfile({}),
        retry: false,
        select: (data) => {
            if (data?.ok && data?.value) {
                return data.value;
            }
        },
    });

    useEffect(() => {
        if (!data) return;

        const { eid, id, liquid_id } = data;

        dispatch(setYatPage(data));
        dispatch(getYatPageItems(eid, id, true));
        dispatch(getUserSettings());
        dispatch(
            getLiquidIdCollectionItems({
                collectionId: liquid_id,
                eid,
                pageId: id,
                isEditMode: true,
            }),
        );
    }, [data, dispatch]);

    return { data, ...rest };
}
